// Data Akademik (Tahun Ajaran, Semester, Kurikulum, dll)

export const dataTahunAkademik = [
    { ta_id: 1, tahun_akademik: "2024/2025", status: 1, is_active: 1 },
    { ta_id: 2, tahun_akademik: "2023/2024", status: 1, is_active: 0 },
    { ta_id: 3, tahun_akademik: "2022/2023", status: 1, is_active: 0 },
    { ta_id: 4, tahun_akademik: "2021/2022", status: 1, is_active: 0 },
    { ta_id: 5, tahun_akademik: "2020/2021", status: 1, is_active: 0 }
];

export const dataSemester = [
    { semester_id: 1, semester_nama: "Ganjil", kode: "1" },
    { semester_id: 2, semester_nama: "Genap", kode: "2" },
    { semester_id: 3, semester_nama: "Pendek", kode: "3" }
];

export const dataKurikulum = [
    { kurikulum_id: 1, kurikulum_nama: "Kurikulum 2020", prodi_id: 1, tahun: 2020, status: 1 },
    { kurikulum_id: 2, kurikulum_nama: "Kurikulum 2020", prodi_id: 2, tahun: 2020, status: 1 },
    { kurikulum_id: 3, kurikulum_nama: "Kurikulum 2019", prodi_id: 3, tahun: 2019, status: 1 },
    { kurikulum_id: 4, kurikulum_nama: "Kurikulum 2020", prodi_id: 4, tahun: 2020, status: 1 },
    { kurikulum_id: 5, kurikulum_nama: "Kurikulum 2020", prodi_id: 5, tahun: 2020, status: 1 },
    { kurikulum_id: 6, kurikulum_nama: "Kurikulum 2020", prodi_id: 6, tahun: 2020, status: 1 }
];

export const dataHari = [
    { hari_id: 1, hari_nama: "Senin" },
    { hari_id: 2, hari_nama: "Selasa" },
    { hari_id: 3, hari_nama: "Rabu" },
    { hari_id: 4, hari_nama: "Kamis" },
    { hari_id: 5, hari_nama: "Jumat" },
    { hari_id: 6, hari_nama: "Sabtu" }
];

export const dataJam = [
    { jam_id: 1, jam_mulai: "07:00", jam_selesai: "07:50", sesi: 1 },
    { jam_id: 2, jam_mulai: "07:50", jam_selesai: "08:40", sesi: 2 },
    { jam_id: 3, jam_mulai: "08:40", jam_selesai: "09:30", sesi: 3 },
    { jam_id: 4, jam_mulai: "09:30", jam_selesai: "10:20", sesi: 4 },
    { jam_id: 5, jam_mulai: "10:20", jam_selesai: "11:10", sesi: 5 },
    { jam_id: 6, jam_mulai: "11:10", jam_selesai: "12:00", sesi: 6 },
    { jam_id: 7, jam_mulai: "12:30", jam_selesai: "13:20", sesi: 7 },
    { jam_id: 8, jam_mulai: "13:20", jam_selesai: "14:10", sesi: 8 },
    { jam_id: 9, jam_mulai: "14:10", jam_selesai: "15:00", sesi: 9 },
    { jam_id: 10, jam_mulai: "15:00", jam_selesai: "15:50", sesi: 10 },
    { jam_id: 11, jam_mulai: "15:50", jam_selesai: "16:40", sesi: 11 },
    { jam_id: 12, jam_mulai: "16:40", jam_selesai: "17:30", sesi: 12 }
];

export const dataRuangan = [
    { ruangan_id: 1, ruangan_nama: "R.101", gedung: "Gedung A", kapasitas: 40, status: 1 },
    { ruangan_id: 2, ruangan_nama: "R.102", gedung: "Gedung A", kapasitas: 40, status: 1 },
    { ruangan_id: 3, ruangan_nama: "R.103", gedung: "Gedung A", kapasitas: 35, status: 1 },
    { ruangan_id: 4, ruangan_nama: "R.201", gedung: "Gedung A", kapasitas: 40, status: 1 },
    { ruangan_id: 5, ruangan_nama: "R.202", gedung: "Gedung A", kapasitas: 40, status: 1 },
    { ruangan_id: 6, ruangan_nama: "Lab Komputer 1", gedung: "Gedung B", kapasitas: 30, status: 1 },
    { ruangan_id: 7, ruangan_nama: "Lab Komputer 2", gedung: "Gedung B", kapasitas: 30, status: 1 },
    { ruangan_id: 8, ruangan_nama: "Lab Jaringan", gedung: "Gedung B", kapasitas: 25, status: 1 },
    { ruangan_id: 9, ruangan_nama: "Lab Mesin", gedung: "Gedung C", kapasitas: 20, status: 1 },
    { ruangan_id: 10, ruangan_nama: "Aula", gedung: "Gedung Utama", kapasitas: 200, status: 1 }
];

export const dataGradeNilai = [
    { grade_id: 1, grade: "A", nilai_min: 80, nilai_max: 100, bobot: 4.00 },
    { grade_id: 2, grade: "A-", nilai_min: 75, nilai_max: 79.99, bobot: 3.75 },
    { grade_id: 3, grade: "B+", nilai_min: 70, nilai_max: 74.99, bobot: 3.50 },
    { grade_id: 4, grade: "B", nilai_min: 65, nilai_max: 69.99, bobot: 3.00 },
    { grade_id: 5, grade: "B-", nilai_min: 60, nilai_max: 64.99, bobot: 2.75 },
    { grade_id: 6, grade: "C+", nilai_min: 55, nilai_max: 59.99, bobot: 2.50 },
    { grade_id: 7, grade: "C", nilai_min: 50, nilai_max: 54.99, bobot: 2.00 },
    { grade_id: 8, grade: "D", nilai_min: 40, nilai_max: 49.99, bobot: 1.00 },
    { grade_id: 9, grade: "E", nilai_min: 0, nilai_max: 39.99, bobot: 0.00 }
];

// Dropdown functions
export const dropdownTahunAkademik = dataTahunAkademik.map(t => ({
    value: t.ta_id,
    label: t.tahun_akademik
}));

export const dropdownSemester = dataSemester.map(s => ({
    value: s.semester_id,
    label: s.semester_nama
}));

export const dropdownKurikulum = dataKurikulum.map(k => ({
    value: k.kurikulum_id,
    label: k.kurikulum_nama
}));

export const dropdownHari = dataHari.map(h => ({
    value: h.hari_id,
    label: h.hari_nama
}));

export const dropdownJam = dataJam.map(j => ({
    value: j.jam_id,
    label: `${j.jam_mulai} - ${j.jam_selesai}`
}));

export const dropdownRuangan = dataRuangan.map(r => ({
    value: r.ruangan_id,
    label: `${r.ruangan_nama} (${r.gedung})`
}));

export default {
    dataTahunAkademik,
    dataSemester,
    dataKurikulum,
    dataHari,
    dataJam,
    dataRuangan,
    dataGradeNilai
};
